// src/components/shared/regions.js
export const REGIONS = {
    '': ['전체 (시/도)'],
  
    // ① 서울특별시: 25개 전 자치구
    '서울특별시': [
      '전체 (구)',
      '종로구','중구','용산구','성동구','광진구',
      '동대문구','중랑구','성북구','강북구','도봉구',
      '노원구','은평구','서대문구','마포구','양천구',
      '강서구','구로구','금천구','영등포구','동작구',
      '관악구','서초구','강남구','송파구','강동구'
    ],
  
    // ② 구미시: 읍·면·동 행정구역 (시스템에서는 '구/군' 드롭다운으로 사용)
    //   - 읍: 산동읍, 고아읍
    //   - 면: 장천면, 도개면, 해평면, 옥성면
    //   - 동: 원평동, 도량동, 지산동, 선주원남동, 형곡1동, 형곡2동,
    //         신평1동, 신평2동, 신평3동, 공단1동, 공단2동, 진미동,
    //         인동동, 양포동, 비산동, 송정동
    '구미시': [
      '전체 (구)',
      // 읍
      '산동읍','고아읍',
      // 면
      '장천면','도개면','해평면','옥성면',
      // 동
      '원평동','도량동','지산동','선주원남동','형곡1동','형곡2동',
      '신평1동','신평2동','신평3동','공단1동','공단2동','진미동',
      '인동동','양포동','비산동','송정동'
    ],
  }
  